import React from 'react';
import Layout from '../components/Layout';
import CustomerForm from '../components/CustomerForm';
import { useParams } from 'react-router-dom';

const ViewCustomer = () => {
  const { customerId } = useParams();
  
  return (
    <Layout>
      <CustomerForm mode="view" customerId={customerId} />
    </Layout>
  );
};

export default ViewCustomer;
